const { REACT_APP_DNS_CHAT, REACT_APP_DNS_CHATWEB, REACT_APP_DNS_AOCS } = process.env

const config = {
  chatStandalone: REACT_APP_DNS_CHAT,
  chatwebScript: `${REACT_APP_DNS_CHATWEB}/nixi1-chatweb.js`,
  aocs: REACT_APP_DNS_AOCS,
  aocsScript: `${REACT_APP_DNS_AOCS}/nixi1-aocs.js`
}

module.exports = config
